var React = require('react');

function LinkedinNews (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Vector","d":"M3.90067 2.5452C3.90033 3.29614 3.44474 3.97189 2.74874 4.25381C2.05274 4.53574 1.2553 4.36754 0.732455 3.82852C0.209609 3.2895 0.0657674 2.48731 0.368749 1.80021C0.671739 1.11312 1.36105 0.678319 2.11165 0.700848C3.10858 0.730772 3.90112 1.54781 3.90067 2.5452ZM3.956 5.75438H0.267291V17.3H3.956V5.75438ZM9.78418 5.75438H6.11389V17.3H9.74729V11.2413C9.74729 7.86614 14.1461 7.5526 14.1461 11.2413V17.3H17.7887V9.98714C17.7887 4.29734 11.2781 4.50944 9.74729 7.30361L9.78418 5.75438Z","fill":"#008060"}));
}

LinkedinNews.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = LinkedinNews;

LinkedinNews.default = LinkedinNews;
